import { render } from "./PolisButton.vue?vue&type=template&id=3a7dca95&scoped=true"
import script from "./PolisButton.vue?vue&type=script&lang=js"
export * from "./PolisButton.vue?vue&type=script&lang=js"

import "./PolisButton.vue?vue&type=style&index=0&id=3a7dca95&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7dca95"]])

export default __exports__